// Mirror of modules/qrcode/.../FeatureEntitlements.kt — keep in lockstep so
// the UI can predict whether a render call would breach the free-plus
// vanity-stack cap before it leaves the browser. ADR-019 §4.1.

import type { AnonymousDesign } from "@qrody/api-client/render";

/** Same value as backend `FREEMIUM_PLUS_VANITY_LIMIT`. */
export const FREEMIUM_PLUS_VANITY_LIMIT = 3;

const DEFAULT_FOREGROUND = "#000000";
const DEFAULT_BACKGROUND = "#FFFFFF";

/**
 * Counts how many vanity-stacking knobs the [design] has activated. The
 * default state — NONE-frame, MEDIUM-ECC, no logo, default colours —
 * returns 0. Mirrors `countActiveVanityFeatures` on the backend.
 */
export function countActiveVanityFeatures(design: AnonymousDesign): number {
  let count = 0;

  // Frame: NONE + SIMPLE are baseline.
  if (design.frame !== "NONE" && design.frame !== "SIMPLE") count += 1;

  // ECC: MEDIUM is the silent default.
  if (design.ecc !== "MEDIUM") count += 1;

  // Custom colours — fg+bg bundle into one slot.
  if (
    design.foreground.toLowerCase() !== DEFAULT_FOREGROUND.toLowerCase() ||
    design.background.toLowerCase() !== DEFAULT_BACKGROUND.toLowerCase()
  ) {
    count += 1;
  }

  return count;
}

/** True iff the active design exactly fits the free-plus envelope. */
export function fitsFreePlusEnvelope(design: AnonymousDesign): boolean {
  return countActiveVanityFeatures(design) <= FREEMIUM_PLUS_VANITY_LIMIT;
}
